import type { ReactNode } from 'react';

export const symbol_patient_list: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M555.5-436.5Q522-470 522-521t33.5-84.5Q589-639 640-639t84.5 33.5Q758-572 758-521t-33.5 84.5Q691-403 640-403t-84.5-33.5ZM430-160q-13 0-21.5-8.5T400-190v-36q0-19 9-36t24-24q45-32 98.5-47.5T640-349q55 0 108 17t99 46q14 10 23.5 25.5T880-226v36q0 13-8.5 21.5T850-160H430Zm25-71v11h370v-11q-39-26-90-42t-95-16q-44 0-95.5 16T455-231Zm227-248q16-16 16-42t-16-42q-16-16-42-16t-42 16q-16 16-16 42t16 42q16 16 42 16t42-16Zm-42-42Zm0 301ZM396-410H150q-13 0-21.5-8.5T120-440q0-13 8.5-21.5T150-470h246q13 0 21.5 8.5T426-440q0 13-8.5 21.5T396-410Zm167-330H150q-13 0-21.5-8.5T120-770q0-13 8.5-21.5T150-800h413q13 0 21.5 8.5T593-770q0 13-8.5 21.5T563-740Zm-94 165H150q-13 0-21.5-8.5T120-605q0-13 8.5-21.5T150-635h350q-11 13-18.5 28T469-575Z"
		/>
	</svg>
);
